import { Typography, TextField, Button, Grid, Box } from '@mui/material';
import { createContext, useContext } from "react";
import { ContextSession } from '../../services/ContextSession';
import './fichadni.component.css';

export default function FichaPadre({ padreData }) {
  const { sessionData } = useContext(ContextSession);
  const { nombre, apellido } = sessionData;
 
  
  return (
    <>
       {padreData != null && (
          <>
        <div className="ficha">
            <div className="datos-container">
              <div className="datos">
                <div className="seccion">
                  <h2>Datos Del Padre</h2>
                  <table>
                    <tbody>
                    <tr>
                        <td className="etiqueta1">Identidad:</td>
                        <td className="valor1">{padreData.padre.numinscripcion.toUpperCase()}</td>
                      </tr>
                      <tr>
                        <td className="etiqueta">Nombres:</td>
                        <td className="valor">{padreData.padre.nombres.toUpperCase()}</td>
                      </tr>
                      <tr>
                        <td className="etiqueta1">Apellidos:</td>
                        <td className="valor1">{padreData.padre.primerapellido.toUpperCase()} {padreData.padre.segundoapellido.toUpperCase()}</td>
                      </tr>
                      <tr>
                        <td className="etiqueta">Sexo:</td>
                        <td className="valor">{padreData.padre.sexo.toUpperCase()}</td>
                      </tr>
                      <tr>
                        <td className="etiqueta1">Fecha Nacimiento:</td>
                        <td className="valor1">{padreData.padre.fechadenacimiento}</td>
                      </tr>
                      <tr>
                        <td className="etiqueta">Estado Civil:</td>
                        <td className="valor">{padreData.padre.estadocivil.toUpperCase()}</td>
                      </tr>
                      <tr>
                        <td className="etiqueta1">Estado Vivencia:</td>
                        <td className="valor1">{padreData.padre.estadovivencia.toUpperCase()}</td>
                      </tr>
                      <tr>
                        <td className="etiqueta">Fecha Defunción:</td>
                        <td className="valor">{padreData.padre.fechadedefuncion}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="seccion">
                  <h2>Datos De La Madre</h2>
                  <table>
                    <tbody>
                    <tr>
                        <td className="etiqueta1">Identidad:</td>
                        <td className="valor1">{padreData.madre.numinscripcion.toUpperCase()}</td>
                      </tr>
                      <tr>
                        <td className="etiqueta">Nombres:</td>
                        <td className="valor">{padreData.madre.nombres.toUpperCase()}</td>
                      </tr>
                      <tr>
                        <td className="etiqueta1">Apellidos:</td>
                        <td className="valor1">{padreData.madre.primerapellido.toUpperCase()} {padreData.madre.segundoapellido.toUpperCase()}</td>
                      </tr>
                      <tr>
                        <td className="etiqueta">Sexo:</td>
                        <td className="valor">{padreData.madre.sexo.toUpperCase()}</td>
                      </tr>
                      <tr>
                        <td className="etiqueta1">Fecha Nacimiento:</td>
                        <td className="valor1">{padreData.madre.fechadenacimiento}</td>
                      </tr>
                      <tr>
                        <td className="etiqueta">Estado Civil:</td>
                        <td className="valor">{padreData.madre.estadocivil.toUpperCase()}</td>
                      </tr>
                      <tr>
                        <td className="etiqueta1">Estado Vivencia:</td>
                        <td className="valor1">{padreData.madre.estadovivencia.toUpperCase()}</td>
                      </tr>
                      <tr>
                        <td className="etiqueta">Fecha Defunción:</td>
                        <td className="valor">{padreData.madre.fechadedefuncion}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div></>
        )
        }
    </>
  );
}

